import React from "react";
import ExportDetails from "../../components/ExportDetails/ExportDetails";
import ExportProcess from "../../components/ExportProcess/ExportProcess";
import WhyChooseUs from "../../components/WhyChooseUs/WhyChooseUs"; 
import ExportGlobe from "../../components/ExportGlobe/ExportGlobe";
import FAQ from "../../components/ExportFAQ/FAQ";
import Footer from "../../components/Footer/Footer"; 
import '../../resources/styling/GlobalStyles.css'; 
import "./Export.css";

const Export = () => {
  return (
    <div className="page-container">
      <main className="main-content">
        
        {/* Hero Section */}
        <section className="export-hero">
          <div className="export-hero-text">
            <h1>Seamless Global Exporting</h1>
            <p>We ship our high-quality furniture around the world with speed, safety, and style.</p>
          </div>

          <div className="export-hero-globe">
            <ExportGlobe />
          </div>  
      </section>


        {/* Why Choose Us Section */}
        <WhyChooseUs />

        {/* Export Details Section */}
        <ExportDetails />

        {/* Export Process Section */}
        <ExportProcess />

        {/* FAQ Section */}
        <FAQ />
      </main>

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default Export;
